
// TODO: v-htmlは非推奨。定数のみ使うので今回は使用。
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'
import Card from '~/components/atoms/Card.vue'
import Button from '~/components/atoms/Button.vue'
// import { Result } from '~/types/api/result'
import * as recommend from '~/consts/recommend'

export default Vue.extend({
  components: {
    Card,
    Button,
  },
  props: {
    service: {
      type: Object,
      required: true,
    } as PropOptions<recommend.Service>,
    display: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      buttons: [],
    }
  },
})
